import 'isomorphic-fetch';
import { EmissionsModel } from '../typings/general';

interface FetchEmissionsOptions {
  readonly faServicesUrl?: string;
  readonly vin: string;
  readonly serviceConfigsServiceConfig?: string;
  readonly mockIds?: string;
  readonly mocksBaseUrl?: string;
}

function createEmissionsUrl(
  params: URLSearchParams,
  vin: string | undefined,
  faServicesUrl?: string,
): string {
  params.set('vin', vin || '');

  return `${faServicesUrl}/emissions?${params.toString()}`;
}

export class EmissionsFetchError extends Error {
  public constructor(message: string, public readonly url?: string) {
    super(message);
  }
}
export async function fetchEmissions({
  vin,
  faServicesUrl,
  serviceConfigsServiceConfig,
  mockIds,
  mocksBaseUrl,
}: FetchEmissionsOptions): Promise<EmissionsModel> {
  const params = new URLSearchParams();

  if (serviceConfigsServiceConfig) {
    params.set('serviceConfigsServiceConfig', serviceConfigsServiceConfig);
  }

  if (mockIds) {
    params.set('mockIds', mockIds);
  }

  if (mocksBaseUrl) {
    params.set('mocksBaseUrl', mocksBaseUrl);
  }

  const response = await fetch(createEmissionsUrl(params, vin, faServicesUrl));
  const emissions = await response.json();

  if (response.status >= 400) {
    throw new EmissionsFetchError(emissions.message, faServicesUrl);
  }
  return emissions;
}
